import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { useFormattedUserListOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const HikeModal = ({ onSubmit, show = false, handleClose, locationCode }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  const hikePercentageAmountCalculator = () => {
    const currentBaseSalary = watch("currentBaseSalary");
    const hikePercentage = watch("hikePercentage");
    const hikeAmount = (currentBaseSalary * hikePercentage) / 100;
    const newSalary = Number(currentBaseSalary) + Number(hikeAmount);
    setValue("hikeAmount", Number(hikeAmount).toFixed(2));
    setValue("newSalary", Number(newSalary).toFixed(2));
  };

  const hikeAmountPercentageCalculator = () => {
    const currentBaseSalary = watch("currentBaseSalary");
    const hikeAmount = watch("hikeAmount");
    const hikePercentage = (hikeAmount * 100) / currentBaseSalary;
    const newSalary = Number(currentBaseSalary) + Number(hikeAmount);
    setValue("hikePercentage", Number(hikePercentage).toFixed(2));
    setValue("newSalary", Number(newSalary).toFixed(2));
  };

  const userListOptions = useFormattedUserListOption({
    companyCode: watch("companyCode"),
    locationCode,
  });
  

  
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Update Hike Details</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row row">
            <div className="col-md-6 mb-3">
              <Input
                name="currentBaseSalary"
                label="Current Base Salary"
                placeholder="Current Base Salary"
                className={`form-control ${
                  errors.currentBaseSalary ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Current Base Salary is requried"
                readOnly={true}
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="hikePercentage"
                type="text"
                placeholder="Hike Percentage"
                className={`form-control ${
                  errors.hikePercentage ? "is-invalid" : ""
                }`}
                label="Hike Percentage"
                labelClassName="form-label"
                required={true}
                requiredMessage="Hike Percentage is required"
                onBlur={hikePercentageAmountCalculator}
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="hikeAmount"
                type="text"
                placeholder="Hike Amount"
                className={`form-control ${
                  errors.hikeAmount ? "is-invalid" : ""
                }`}
                label="Hike Amount"
                labelClassName="form-label"
                required={true}
                requiredMessage="Hike Amount is required"
                onBlur={hikeAmountPercentageCalculator}
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="newSalary"
                type="text"
                placeholder="New Salary"
                className={`form-control ${
                  errors.newSalary ? "is-invalid" : ""
                }`}
                label="New Salary"
                labelClassName="form-label"
                required={true}
                requiredMessage="New Salary is required"
              />
            </div>
            <div className="col-md-6  mb-3">
              <Input
                name="effectiveDate"
                type="date"
                placeholder=""
                className={`form-control ${
                  errors.effectiveDate ? "is-invalid" : ""
                }`}
                label="Effective Date"
                labelClassName="form-label"
                required={true}
                requiredMessage="Effective Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={watch("effectiveDate")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                disabledDate={(current) => {
                  return current < dayjs().subtract(1, "day").endOf("day");
                }}
              />
            </div>

            <div className="col-md-6 mb-3">
              <Input
                name="isApproved"
                type="commonSelect"
                placeholder="Approved Status"
                className={`form-control ${
                  errors.isApproved ? "is-invalid" : ""
                }`}
                label="Approved Status"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="is Approved is required"
                onSelect={(selectedOption) => {
                  setValue("isApproved", selectedOption);
                  trigger("isApproved");
                }}
                defaultValue={watch("isApproved")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-md-6 mb-3">
              <Input
                name="approvedBy"
                type="commonSelect"
                placeholder="Approved By"
                className={`form-control ${
                  errors.approvedBy ? "is-invalid" : ""
                }`}
                label="Approved By"
                labelClassName="form-label"
                optionData={userListOptions}
                onSelect={(selectedOption) => {
                  setValue("approvedBy", selectedOption);
                  trigger("approvedBy");
                }}
                required={watch("isApproved") ? true : false}
                requiredMessage="Approved By is required"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-md-6  mb-3">
              <Input
                name="approvedDate"
                type="date"
                placeholder=""
                className={`form-control ${
                  errors.approvedDate ? "is-invalid" : ""
                }`}
                label="Approved Date"
                labelClassName="form-label"
                requiredMessage="Approved Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={watch("approvedDate")}
                required={watch("isApproved") ? true : false}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

HikeModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  locationCode : PropTypes.string
};

export default HikeModal;
